import { GlyphLoading } from "#root/components/glyphs";
import type { CorrespondenceDetailItem } from "#root/schema/correspondence";
import { marked } from "marked";

function base64ToFile(base64Data: string, type: string, filename: string) {
  const sliceSize = 1024;
  const byteCharacters = atob(base64Data);
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);

  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);

    const bytes = new Array(end - begin);
    let offset = begin,
      i = 0;
    for (; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new File(byteArrays, filename, { type });
}

interface CorrespondencePreviewProps {
  preview?: CorrespondenceDetailItem;
}

export function CorrespondencePreview({ preview }: CorrespondencePreviewProps) {
  if (!preview) {
    return <GlyphLoading/>;
  }
  return (
    <div className="correspondence-preview">
      <h3>{preview.subject}</h3>
      <table className="correspondence-header">
        <tbody>
        <tr>
          <th>From:</th>
          <td>{preview.from}</td>
        </tr>
        <tr>
          <th>To:</th>
          <td>{preview.to}</td>
        </tr>
        {preview.cc ? (
          <tr>
            <th>CC:</th>
            <td>{preview.cc}</td>
          </tr>
        ) : null}
        {preview.bcc ? (
          <tr>
            <th>BCC:</th>
            <td>{preview.bcc}</td>
          </tr>
        ) : null}
        </tbody>
      </table>
      <div className="correspondence-body" dangerouslySetInnerHTML={{ __html: marked.parse(preview.body || "", { async: false }) }}/>
      {preview.attachments && (
        <div className="attachments">
          <h2>Attachments</h2>
          {preview.attachments.map(({ filename, content, contentType, encoding }) => {
            if (encoding !== "base64") return null;

            const file = base64ToFile(content, contentType, filename);
            return (
              <a target="_blank" href={URL.createObjectURL(file)} rel="noopener">
                {filename}
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}
